export const IMAGES = {
  heroTopdown:
    "https://static.prod-images.emergentagent.com/jobs/879ae4ec-2dff-4c93-bf21-ef9c4f1851c2/images/3d7daa78bfd30dc9bb1d2175d6364df3ad30fba5a40c39681c037a312c9e7ee6.png",
  cabinNight:
    "https://static.prod-images.emergentagent.com/jobs/879ae4ec-2dff-4c93-bf21-ef9c4f1851c2/images/17e3dc3e5fe6a6ec585b53c65f0352d4ccadd9c50d3941bf5d996a7b5e2f1517.png",
  berriesForest:
    "https://static.prod-images.emergentagent.com/jobs/879ae4ec-2dff-4c93-bf21-ef9c4f1851c2/images/77680c7d60d36258d8362ed8e89e5e6563eeb78879294002737a45fcb51d8120.png",
  emptySetup:
    "https://static.prod-images.emergentagent.com/jobs/879ae4ec-2dff-4c93-bf21-ef9c4f1851c2/images/7bc6154b507f826704cb53c7cc66a7a163fa75e256211acc96e294e0f2d656a8.png",
};

export const TICKER_ITEMS = [
  "BREAKING: LIGER SPOTTED FISHING AT UNDISCLOSED LAKE",
  "CLASH ROYALE SERVER TRAFFIC SPIKES IN REMOTE WOODLAND AREA",
  "DONI BOBES: 'THE SERVER ISN'T THE SAME WITHOUT HIM'",
  "LYNIX REFRESHES LIGER'S CHANNEL FOR 14TH CONSECUTIVE HOUR",
  "LOCAL CABIN OWNERS REPORT MYSTERIOUS ELECTRICITY BILLS",
  "SWEET BERRY PRICES SURGE NEAR TAIGA BIOME",
  "NO NEW UPLOADS: DAY 127 OF THE GREAT SILENCE",
];

export const CHAPTERS = [
  {
    num: "01",
    title: "The Vanishing",
    paragraphs: [
      "It began, as these things often do, with silence. No upload on Tuesday. No stream on Friday. No cryptic community post, no 'big announcement coming soon.' Liger — the Minecraft YouTuber whose redstone contraptions and chaotic SMP moments defined a generation of playlists — simply logged off, and the internet has been holding its breath ever since.",
      "Sources close to the creator confirm what many suspected: this is not a scandal, not burnout in the dramatic sense, and definitely not a Fortnite pivot. Liger has taken deliberate time off to connect with nature and relax — and he will not return, we're told, until he is ready. No date. No countdown. Just trees.",
    ],
    image: null,
  },
  {
    num: "02",
    title: "Fishing & Berries: The Survival Update",
    paragraphs: [
      "Deep in an undisclosed stretch of forest, Liger is reportedly living almost entirely off the land. His diet, according to those who have seen him, consists of two food groups: fish he catches himself, and wild berries foraged from the underbrush. It is, in the most literal sense possible, a hardcore survival run — except this time there are no hearts on screen and no respawn.",
      "Witnesses describe a man at peace. Early mornings by the water, rod in hand, waiting with the patience of someone who once AFK-fished for twelve hours straight for a Mending book. 'He's basically speedrunning inner peace,' one hiker reported. 'He didn't even flinch when his line snapped. Old Liger would have rage-quit.'",
    ],
    image: {
      src: "berriesForest",
      caption:
        "FIELD PHOTO — Liger foraging sweet berries in the taiga. Sustainability rating: surprisingly high.",
    },
  },
  {
    num: "03",
    title: "The Clash Royale Situation",
    paragraphs: [
      "There is, however, one complication in this otherwise wholesome tale of digital detox — and it involves an extension cord.",
      "Multiple cabin owners in the region have reported unexplained spikes in their electricity bills, along with sightings of a suspicious cable snaking out of their exterior outlets and into the treeline. Investigators followed one such cable and discovered its purpose: Liger, it turns out, has been siphoning electricity from nearby cabins to keep his phone charged — not for emergencies, not to check messages, but to play Clash Royale.",
      "'Connecting with nature' apparently has a loophole, and that loophole is ladder pushes at 2 AM under the stars. When asked for comment, Liger reportedly emote-spammed and disconnected.",
    ],
    image: {
      src: "cabinNight",
      caption:
        "EXHIBIT A — The cable in question. Cabin owner unaware. Trophy count: climbing.",
    },
  },
  {
    num: "04",
    title: "The Silence of the Server",
    paragraphs: [
      "Perhaps the most striking detail of the hiatus is its totality. Liger has not been seen online since his departure. No Discord status. No sneaky alt account. Not a single Minecraft video recorded with friends — a fact fans have verified with the obsessive rigor of forensic accountants, cross-referencing every collab upload from his usual circle.",
      "His recording setup sits exactly as he left it. The chair is empty. The mic is cold. The SMP world file, friends confirm, has been backed up in triplicate and left untouched, 'like a museum,' awaiting the day its most chaotic resident walks back through the spawn gate.",
    ],
    image: {
      src: "emptySetup",
      caption: "Day 127 — The setup remains untouched. The dust has its own dust.",
    },
  },
];

export const QUOTES = [
  {
    id: "doni",
    quote:
      "Every day I load up the server and just stare at his base. The pranks aren't the same when there's no one to scream at me afterwards. Come home, Liger. I'll even stop replacing your diamonds with coal. Maybe.",
    author: "DONI BOBES",
    role: "YOUTUBER · LONGTIME FRIEND · SERIAL PRANKSTER",
  },
  {
    id: "lynix",
    quote:
      "I respect the nature thing, I do. But the man is out there eating berries and stealing electricity to play Clash Royale. Just come back and play Minecraft. The boys are waiting. The server is waiting. I'm waiting.",
    author: "LYNIX",
    role: "YOUTUBER · FRIEND · CHANNEL-REFRESH WORLD RECORD HOLDER",
  },
];

export const TRENDING = [
  { id: 1, tag: "FORAGING", title: "10 berries Liger is probably eating right now, ranked by a nutritionist" },
  { id: 2, tag: "GUIDE", title: "How to siphon electricity for mobile gaming (a purely theoretical guide)" },
  { id: 3, tag: "ANALYSIS", title: "We analyzed 4 years of Liger uploads to predict his return date. It's soon. Probably." },
  { id: 4, tag: "COMMUNITY", title: "Doni Bobes builds shrine to Liger on SMP; Lynix adds candles" },
  { id: 5, tag: "ECONOMY", title: "Fishing rod sales up 400% among fans 'training for his comeback'" },
  { id: 6, tag: "ESPORTS?", title: "Anonymous Clash Royale player from forest region hits top 500 global" },
];

export const STATS = [
  { label: "DAYS OFFLINE", value: "127" },
  { label: "FISH CAUGHT (EST.)", value: "1,204" },
  { label: "BERRIES CONSUMED", value: "∞" },
  { label: "CROWNS STOLEN", value: "8,916" },
];
